import { render, staticRenderFns } from "./RequestUserAgent.vue?vue&type=template&id=47722a64&scoped=true"
import script from "./RequestUserAgent.vue?vue&type=script&lang=js"
export * from "./RequestUserAgent.vue?vue&type=script&lang=js"
import style0 from "./RequestUserAgent.vue?vue&type=style&index=0&id=47722a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47722a64",
  null
  
)

export default component.exports